import { render, staticRenderFns } from "./preciosTransForm.vue?vue&type=template&id=b275aadc&scoped=true"
import script from "./preciosTransForm.vue?vue&type=script&lang=js"
export * from "./preciosTransForm.vue?vue&type=script&lang=js"
import style0 from "./preciosTransForm.vue?vue&type=style&index=0&id=b275aadc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b275aadc",
  null
  
)

export default component.exports